import React from "react";
import { brand } from "../brands/index.js";
import { t } from "../i18n/index.js";

export function SiteHomeLink() {
  return (
    <>
      <ExternalHeaderLink href={brand.homeSiteUrl}>
        {t.siteHomeLink.label}
      </ExternalHeaderLink>
      {brand.developerPortalUrl && (
        <ExternalHeaderLink href={brand.developerPortalUrl}>
          {t.siteHomeLink.developerPortal}
        </ExternalHeaderLink>
      )}
    </>
  );
}

function ExternalHeaderLink({ href, children }: React.PropsWithChildren<{ href: string }>) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "4px",
        padding: "4px 10px",
        fontSize: "13px",
        fontWeight: 500,
        color: "var(--foreground)",
        background: "transparent",
        borderRadius: "9999px",
        textDecoration: "none",
        whiteSpace: "nowrap",
        transition: "color 150ms ease, background 150ms ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.color = "var(--brand-purple-solid)";
        e.currentTarget.style.background = "var(--brand-gradient-soft)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.color = "var(--foreground)";
        e.currentTarget.style.background = "transparent";
      }}
    >
      {children}
      <svg
        width="12"
        height="12"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M7 17L17 7M7 7h10v10" />
      </svg>
    </a>
  );
}
